import React, { useContext, useEffect } from 'react';
import { withRouter } from 'react-router-dom';
import _ from 'lodash';
import { connect } from 'react-redux';
import withForm from 'modules/common/hoc/withForm';
import Modal from 'modules/common/components/Modal';
import PropTypes from 'prop-types';
import { ModalContext } from 'App';
import ImagePlaceholder from 'assets/img/image-placeholder.jpg';
import * as action from '../action';
import * as c from '../constant';

function EditProfileModal({
  profile,
  setFormData,
  formData,
  createInput,
  createInputMobileNumber,
  createTelephoneNumber,
  createUploader,
  updateProfile,
  UpdateInfo,
}) {
  const setModal = useContext(ModalContext);

  const OnSetFormData = () => {
    setFormData({
      photo: profile.attributes.photo || '',
      first_name: profile.attributes.first_name || '',
      middle_name: profile.attributes.middle_name || '',
      last_name: profile.attributes.last_name || '',
      mobile_number: profile.attributes.mobile_number || '',
      telephone_number: profile.attributes.telephone_number || '',
      email: profile.attributes.email || '',
      address: profile.attributes.address || '',
    });
  };

  const handleOnSubmit = (e) => {
    e.preventDefault();
    if (_.isObject(formData.photo)) {
      const args = {
        ...formData,
        photo: formData.photo.cdnUrl,
      };
      updateProfile(profile.id, args, () => {
        UpdateInfo();
        setModal({ isOpen: false });
      });
      return;
    }
    updateProfile(profile.id, formData, () => {
      UpdateInfo();
      setModal({ isOpen: false });
    });
  };

  const closeModal = (e) => {
    e.preventDefault();
    setModal({ isOpen: false });
  };

  useEffect(() => {
    if (!_.isEmpty(profile)) {
      OnSetFormData();
    }
  }, []);

  useEffect(() => {
    if (!_.isEmpty(profile)) {
      OnSetFormData();
    }
  }, [profile]);

  return (
    <Modal.Body>
      <form onSubmit={handleOnSubmit}>
        <div className="row d-flex justify-content-center">
          <div className="col-4">
            <img
              className="w-100 rounded"
              src={
                !_.isObject(_.get(formData, 'photo') || '')
                  ? _.get(formData, 'photo') || ImagePlaceholder
                  : _.get(formData, 'photo.cdnUrl') || ImagePlaceholder
              }
              alt=""
            />
          </div>
        </div>
        <div className="row d-flex justify-content-center">
          <div className="col-4 form-group">
            {createUploader(
              { key: 'photo', label: 'Browse' },
              { required: true, crop: '1:1' }
            )}
          </div>
        </div>

        <div className="row">
          <div className="col-6 form-grousp">
            {createInput(
              { key: 'first_name', label: 'First Name:' },
              { required: true, placeholder: 'First Name' }
            )}
          </div>
          <div className="col-6 form-group">
            {createInput(
              { key: 'middle_name', label: 'Middle Name:' },
              { required: true, placeholder: 'Middle Name' }
            )}
          </div>
          <div className="col-6 form-group">
            {createInput(
              { key: 'last_name', label: 'Last Name:' },
              { required: true, placeholder: 'Last Name' }
            )}
          </div>
          <div className="col-6 form-group">
            {createInputMobileNumber(
              { key: 'mobile_number', label: 'Mobile No.:' },
              { placeholder: 'Mobile No.' }
            )}
          </div>
          <div className="col-6 form-group">
            {createTelephoneNumber(
              { key: 'telephone_number', label: 'Telephone No.:' },
              { placeholder: 'Telephone No.' }
            )}
          </div>
          <div className="col-12 form-group">
            {createInput(
              { key: 'address', label: 'Address:' },
              { required: true, placeholder: 'Address' }
            )}
          </div>
        </div>
        <div className="d-flex justify-content-center">
          <button type="submit" className="mt-3 btn btn-primary cms-bg-color-primary cms-outline-primary  mr-3">
            <span className="font-weight-bold">Submit</span>
          </button>
          <button
            type="button"
            onClick={closeModal}
            className="mt-3 btn btn-dark "
          >
            <span className="font-weight-bold">Cancel</span>
          </button>
        </div>
      </form>
    </Modal.Body>
  );
}

EditProfileModal.propTypes = {
  profile: PropTypes.instanceOf(Object).isRequired,
  updateProfile: PropTypes.instanceOf(Function).isRequired,
  UpdateInfo: PropTypes.instanceOf(Function).isRequired,

  formData: PropTypes.instanceOf(Object).isRequired,
  setFormData: PropTypes.instanceOf(Function).isRequired,
  createUploader: PropTypes.instanceOf(Function).isRequired,
  createInput: PropTypes.instanceOf(Function).isRequired,
  createInputMobileNumber: PropTypes.instanceOf(Function).isRequired,
  createTelephoneNumber: PropTypes.instanceOf(Function).isRequired,
};

const mapStateToProps = ({ api }) => ({
  profile: _.get(api, `${c.GET_PROFILE}.item`) || {},
});

const enhance = _.flowRight([
  withForm,
  withRouter,
  connect(mapStateToProps, action),
]);

export default enhance(EditProfileModal);
